export default "__VITE_ASSET__C9D4tPBo__"